module.exports = __webpack_public_path__ + "static/media/logo-white.c6089af4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-white.png
// module id = 1865
// module chunks = 0